import { AfterViewInit, Component, computed, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ClaimFlagsService } from '@services/claim-flags.service';
import { PatientAssistanceRequestViewModel } from '@services/models/patient-assistance-request-view.model';

@Component({
  selector: 'app-shared-claim-flags',
  templateUrl: './claim-flags.component.html',
  styleUrl: './claim-flags.component.scss',
  standalone: false,
})
export class ClaimFlagsComponent implements AfterViewInit {
  private destroyRef = inject(DestroyRef);
  protected claimFlagsService = inject(ClaimFlagsService);

  claim = input.required<PatientAssistanceRequestViewModel>();
  size = input<'regular' | 'small'>('regular');
  flagsCount = signal(0);
  flagsFillsRemaning = computed(() => {
    const refillsAuthorizedCount = this.claim().refillsAuthorizedCount ?? 0;
    const fillNumber = Number.parseInt(this.claim().fillNumber ?? '0');
    return Math.max(0, refillsAuthorizedCount - fillNumber);
  });

  ngAfterViewInit() {
    this.claimFlagsService
      .getFlagsSettings(this.claim().tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(flagsSettings => {
        const flagsSettingsFiltered = flagsSettings.filter(f => f.category === 'Claim Profiling');
        let count = 0;
        for (const flagName of this.claim().flagsList) {
          if (flagsSettingsFiltered.findIndex(flagSetting => flagSetting.name === flagName) !== -1) count += 1;
        }
        this.flagsCount.set(count);
      });
  }
}
